import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Catalogue.css";

const toDownloadUrl = (url) =>
  url.replace("/upload/", "/upload/fl_attachment/");

const catalogueData = [
  {
    category: "Antique",
    icon: "🏺",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1718962798/1_1.png",
    pdfs: [
      {
        name: "RK Antique Catalogue",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772631769/RK_Antique_Catalogue_11zon.pdf",
      },
      {
        name: "RK Antique Collection",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772631770/RK_ANTIQUE_11zon.pdf",
      },
    ],
  },
  {
    category: "Cake Stand",
    icon: "🎂",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1718964193/2_1.jpg",
    pdfs: [
      {
        name: "Cake Stand Collection",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772631910/CAKE_STAND_11zon.pdf",
      },
    ],
  },
  {
    category: "Candle Holder",
    icon: "🕯️",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1718983133/7_1.jpg",
    pdfs: [
      {
        name: "RK Candle Holder Hurricane",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772631932/RK_Candle_holder_Hurricane_11zon.pdf",
      },
      {
        name: "Borosil Candle Holder",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772631929/Borosil_Candle_Holder_11zon.pdf",
      },
    ],
  },
  {
    category: "Candle Stands",
    icon: "🕯️",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1718968912/4_1.jpg",
    pdfs: [
      {
        name: "2025 RK Candle Stand",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772631956/2025_RK_candle_Stand.pdf_11zon.pdf",
      },
    ],
  },
  {
    category: "Candles",
    icon: "🕯️",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1718967610/3_1.jpg",
    pdfs: [
      {
        name: "RK Candles Premium",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772631991/RK_CANDLES_PREMIUM_11zon.pdf",
      },
      {
        name: "RK Candle Votive with Price",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772631992/RK_candle_votive_with_price_11zon.pdf",
      },
      {
        name: "RK Latest Candle",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772631994/RK_LATEST_CANDLE_11zon.pdf",
      },
      {
        name: "More Candles",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772631996/More_candles_11zon.pdf",
      },
    ],
  },
  {
    category: "Christmas Hanging",
    icon: "🎄",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1718970117/5_1.jpg",
    pdfs: [
      {
        name: "2024 Hanging Collection",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632034/2024_hanging_RKOVERSEAS_1_11zon.pdf",
      },
      {
        name: "2025 Hanging Collection",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632027/2025_Hanging_RKOVERSEAS_2_11zon.pdf",
      },
      {
        name: "Black Edition Hanging",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632028/Black_Edition_hanging_rkoverseas_3_11zon.pdf",
      },
      {
        name: "Hanging Items Collection",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632034/HANGINGITEMS_RKOVERSEAS_4_11zon.pdf",
      },
      {
        name: "New Borosil Hanging",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632024/New_borosil_hanging_Catalogue.pdf_5_11zon.pdf",
      },
      {
        name: "RK Hanging Ornaments",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632026/RK_Hanging_Ornaments_6_11zon.pdf",
      },
    ],
  },
  {
    category: "Christmas Tree",
    icon: "🎄",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1718983080/6_1.png",
    pdfs: [
      {
        name: "RK Christmas Tree Catalogue",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632052/RK_Christmas_Tree_Catalogue_11zon.pdf",
      },
    ],
  },
  {
    category: "Drinking Glasses",
    icon: "🍷",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1772786577/1.jpg",
    pdfs: [
      {
        name: "RK Drinking Glass Catalogue",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772786331/Drinking_Glasses.pdf",
      },
    ],
  },
  {
    category: "Jars",
    icon: "🫙",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1718983198/8_1.jpg",
    pdfs: [
      {
        name: "New RK Jars Vol. 1",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632072/New_RK_JARS_1_11zon.pdf",
      },
      {
        name: "RK Jars Vol. 2",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632074/RK_JARS_2_11zon.pdf",
      },
      {
        name: "Wine Bottles & Honey Jars",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632070/Wine_Bottles_and_honey_Jars_3_11zon.pdf",
      },
    ],
  },
  {
    category: "Pumpkins",
    icon: "🎃",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1718983362/9_1.jpg",
    pdfs: [
      {
        name: "RK Pumpkins Catalogue",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632084/RK_Pumpkins_Catalogue_11zon.pdf",
      },
    ],
  },
  {
    category: "Vases",
    icon: "🏵️",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1718983534/10_1.jpg",
    pdfs: [
      {
        name: "Emerald Green RK Vases",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632108/Emerald_Green_RK_votives_Vases_compressed_1_11zon.pdf",
      },
      {
        name: "New Vases Collection",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632105/New_vases_2_11zon.pdf",
      },
      {
        name: "Vase Catalogue",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632107/Vase_Catalogue_3_11zon.pdf",
      },
    ],
  },
  {
    category: "Votives",
    icon: "✨",
    cover:
      "https://res.cloudinary.com/dndg4fwia/image/upload/q_auto,f_auto,/v1718984046/11_1.jpg",
    pdfs: [
      {
        name: "2025 RK Votives Vol. 1",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632134/2025_RK_votives_Catelogue_1_11zon.pdf",
      },
      {
        name: "2025 RK Votives Vol. 2",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632136/2025_RK_votives_Catalogue_2nd_2_11zon.pdf",
      },
      {
        name: "RK Votives New Collection",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632133/RK_votives_Catalogue_-NEW_3_11zon.pdf",
      },
      {
        name: "Votives Catalogue Vol. 4",
        url: "https://res.cloudinary.com/dndg4fwia/image/upload/v1772632139/votives_cataloge_4_11zon.pdf",
      },
    ],
  },
];

const CatalogueCard = ({ cat }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setModalOpen(false);
    document.body.style.overflow = "unset";
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <>
      <div className="cat-card" onClick={openModal}>
        <div className="cat-card__img-wrap">
          <img src={cat.cover} alt={cat.category} loading="lazy" />
          <div className="cat-card__overlay">
            <span>View Catalogues</span>
          </div>
        </div>
        <div className="cat-card__info">
          <span className="cat-card__icon">{cat.icon}</span>
          <h3>{cat.category}</h3>
          <p>
            {cat.pdfs.length} Catalogue{cat.pdfs.length > 1 ? "s" : ""}
          </p>
        </div>
      </div>

      {modalOpen && (
        <div className="cat-modal__backdrop" onClick={closeModal}>
          <div className="cat-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cat-modal__header">
              <h3>
                {cat.icon} {cat.category}
              </h3>
              <button
                className="cat-modal__close"
                onClick={closeModal}
                aria-label="Close catalogue modal"
              >
                ✕
              </button>
            </div>
            <div className="cat-modal__pdfs">
              {cat.pdfs.map((pdf, i) => (
                <div className="cat-card__pdf-item" key={i}>
                  <div className="cat-card__pdf-icon">📄</div>
                  <div className="cat-card__pdf-name">{pdf.name}</div>
                  <div className="cat-card__pdf-actions">
                    <a
                      href={pdf.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cat-card__btn-view"
                      aria-label={`View ${pdf.name}`}
                    >
                      View
                    </a>
                    <a
                      href={toDownloadUrl(pdf.url)}
                      download
                      className="cat-card__btn-download"
                      aria-label={`Download ${pdf.name}`}
                    >
                      ⬇
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const Catalogue = () => {
  return (
    <div className="catalogue-page">
      <Helmet>
        <title>
          Catalogues | RK Overseas — Glass Decorative Items Firozabad, India
        </title>
        <meta
          name="description"
          content="Download or view product catalogues from RK Overseas, Firozabad, India. Browse glass decorative accessories including vases, votives, candle holders, Christmas ornaments and more."
        />
        <meta
          name="keywords"
          content="glass catalogue india, decorative glass catalogue firozabad, vases catalogue india, votives catalogue, candle holders catalogue india, christmas ornaments catalogue, RK Overseas catalogue"
        />
        <link rel="canonical" href="https://rkoverseasindia.com/catalogue" />
      </Helmet>

      <div className="page-banner">
        <h1>Our Catalogues</h1>
        <p className="breadcrumb">Home / Catalogues</p>
      </div>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Browse Collections</h2>
          <div className="section-divider" />
          <p className="section-subtitle">
            Click on any category to explore our product catalogues. View online
            or download for offline reference.
          </p>

          <div className="catalogue-page__grid">
            {catalogueData.map((cat, i) => (
              <CatalogueCard cat={cat} key={i} />
            ))}
          </div>

          <div className="catalogue-page__cta">
            <p>Looking for something specific? Get in touch with our team.</p>
            <Link
              to="/contact"
              className="btn-primary"
              aria-label="Contact RK Overseas team"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Catalogue;
